export default "__VITE_PUBLIC_ASSET__756a1fc5__"